import { IssueDetail } from "@/components/issues/IssueDetail";

export function IssueDetailPage({ id }: { id: string }) {
  return <IssueDetail id={id} />;
}
